import { render, staticRenderFns } from "./interal.vue?vue&type=template&id=2cd61dc8&scoped=true"
import script from "./interal.vue?vue&type=script&lang=js"
export * from "./interal.vue?vue&type=script&lang=js"
import style0 from "./interal.vue?vue&type=style&index=0&id=2cd61dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd61dc8",
  null
  
)

export default component.exports